module.exports = __webpack_public_path__ + "media/images/frontend/heros/forest-4708ae34f5ff766b5ab4f6e75b538d09.jpg";